export const STAKEHOLDER_PREVIEW_CHIP_DRAFT_KEY = 's2r_stakeholder_chip_draft';

export const STAKEHOLDER_PREVIEW_SUGGESTED_QUESTIONS = [
  'What can this assistant help visitors with on our website?',
  'How does it use our website content to answer questions?',
  'Can you show me an example answer for a common visitor question?',
] as const;

export function writeStakeholderChipDraft(message: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(STAKEHOLDER_PREVIEW_CHIP_DRAFT_KEY, message);
  } catch {
    /* ignore */
  }
}

export function readStakeholderChipDraft(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = sessionStorage.getItem(STAKEHOLDER_PREVIEW_CHIP_DRAFT_KEY);
    if (!value) return null;
    sessionStorage.removeItem(STAKEHOLDER_PREVIEW_CHIP_DRAFT_KEY);
    return value;
  } catch {
    return null;
  }
}
